import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dmCenterDatePipe',
  standalone: false,
})
export class DmCenterDatePipe implements PipeTransform {
  transform(
    value: string | Date,
    mode: 'dmCenter' | 'chat' = 'dmCenter'
  ): string {
    const d = new Date(value);
    const now = new Date();

    const diffMs = now.getTime() - d.getTime();
    const diffMinutes = diffMs / 60000;
    const diffHours = diffMinutes / 60;
    const diffDays = diffHours / 24;

    const locale = Intl.DateTimeFormat().resolvedOptions().locale;

    if (diffMinutes < 1) return 'Just now';

    // chat Mode
    if (mode === 'chat') {
      // Time only < 1h
      if (diffMinutes < 60) {
        return new Intl.DateTimeFormat(locale, {
          hour: '2-digit',
          minute: '2-digit',
        }).format(d);
      }

      // > 1 Full date
      return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(d);
    }

  //  dmCenter Mode

    if (diffMinutes < 60) {
      const mins = Math.floor(diffMinutes);
      return `${mins} ${mins === 1 ? 'Min ago' : 'Mins ago'}`;
    }

    if (diffHours < 24) {
      const hours = Math.floor(diffHours);
      return `${hours} ${hours === 1 ? 'Hour ago' : 'Hours ago'}`;
    }

    if (diffHours < 48) return 'Yesterday';

    if (diffDays <= 7) {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
      }).format(d);
    }

    return new Intl.DateTimeFormat(locale, {
      year: '2-digit',
      month: 'numeric',
      day: 'numeric',
    }).format(d);
  }
}
